<template>
  <Dialog :visible="visible" class="irinox-dialog-light order-dialog" :modal="true" :closable="false"
    :dismissableMask="true" :style="{ width: '60vw' }" :breakpoints="{'1600px': '80vw', '1100px': '90vw', '767px': '100vw'}" 
    :draggable="false" @update:visible="updateVisible" @show="show">

    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')" />
      <div>{{ $t('orders.details.title') }}: {{ order.id }}</div>
    </template>

    <div class="irinox-dialog-light-content layout-content">
      <div class="p-grid irinox-form">
        <!-- <div class="p-col-12 p-md-6 p-xl-5 personal-data">
          <div class="p-d-flex p-jc-between p-ai-center p-mb-2">
            <h3>{{ $t('spareParts.cart.personalData') }}</h3>
          </div>
          <div class="">
            <p>
              <label>{{ $t('userinfo.first_name').toLowerCase() }}</label>
              <span>{{ order.personalData?.firstName }}</span>
            </p>
            <p>
              <label>{{ $t('userinfo.last_name').toLowerCase() }}</label>
              <span>{{ order.personalData?.lastName }}</span>
            </p>
            <p>
              <label>{{ $t('company.name').toLowerCase() }}</label>
              <span>{{ order.personalData?.company?.name }}</span>
            </p>
            <p>
              <label>{{ $t('company.taxCode').toLowerCase() }}</label>
              <span>{{ order.personalData?.company?.taxCode }}</span>
            </p>
          </div>
        </div> -->
        <!-- <div class="p-col-12 p-md-6 shipping-data">
          <div class="p-d-flex p-jc-between p-ai-center p-mb-2">
            <h3>{{ $t('spareParts.cart.shippingData') }}</h3>
          </div>
          <div class="">
            <p>
              <label>{{ $t('company.name').toLowerCase() }}</label>
              <span>{{ order.shippingData?.company }}</span>
            </p>
            <p>
              <label>{{ $t('company.address').toLowerCase() }}</label>
              <span>{{ order.shippingData?.address }}</span>
            </p>
            <p>
              <label>{{ $t('company.district').toLowerCase() }}</label>
              <span>{{ order.shippingData?.district }}</span>
            </p>
            <p>
              <label>{{ $t('company.postalCode').toLowerCase() }}</label>
              <span>{{ order.shippingData?.postalCode }}</span>
            </p>
            <p>
              <label>{{ $t('company.city').toLowerCase() }}</label>
              <span>{{ order.shippingData?.city }}</span>
            </p>
            <p>
              <label>{{ $t('company.country').toLowerCase() }}</label>
              <span>{{ order.shippingData?.country }}</span>
            </p>
          </div>
        </div> -->
        <div class="p-col-12 p-pb-1">
          <div class="p-d-flex p-jc-between p-ai-center">
            <h3>{{ $t('spareParts.cart.shippingData') }}</h3>
          </div>
        </div>
        <div class="p-col-12 p-md-6 p-xl-4 shipping-data p-py-1">
          <div class="">
            <p>
              <label>{{ $t('company.name').toLowerCase() }}</label>
              <span>{{ order.shippingData?.company }}</span>
            </p>
            <p>
              <label>{{ $t('company.address').toLowerCase() }}</label>
              <span>{{ order.shippingData?.address }}</span>
            </p>
            <p>
              <label>{{ $t('company.district').toLowerCase() }}</label>
              <span>{{ order.shippingData?.district }}</span>
            </p>
            <!-- <p>
              <label>{{ $t('company.postalCode').toLowerCase() }}</label>
              <span>{{ order.shippingData?.postalCode }}</span>
            </p>
            <p>
              <label>{{ $t('company.city').toLowerCase() }}</label>
              <span>{{ order.shippingData?.city }}</span>
            </p>
            <p>
              <label>{{ $t('company.country').toLowerCase() }}</label>
              <span>{{ order.shippingData?.country }}</span>
            </p> -->
          </div>
        </div>
        <div class="p-col-12 p-md-6 p-xl-8 shipping-data p-py-1">
          <div class="">
            <p>
              <label>{{ $t('company.postalCode').toLowerCase() }}</label>
              <span>{{ order.shippingData?.postalCode }}</span>
            </p>
            <p>
              <label>{{ $t('company.city').toLowerCase() }}</label>
              <span>{{ order.shippingData?.city }}</span>
            </p>
            <p>
              <label>{{ $t('company.country').toLowerCase() }}</label>
              <span>{{ order.shippingData?.country }}</span>
            </p>
          </div>
        </div>
        <div class="p-col-12">
          <div class="p-d-flex p-jc-between p-ai-center">
            <h3>{{ $t('orders.details.spareParts') }}</h3>
          </div>
          <DataTable :value="order.items" stripedRows
              responsiveLayout="stack"
              breakpoint="767px"
              :autoLayout="true" class="after-sales-table "
              sortField="code" :sortOrder="1"
              >

              <Column field="code"></Column>
              <Column field="description"></Column>
              <Column field="comment">
                <template #body="slotProps">
                  <i class="icon-tab_extra" v-tooltip="slotProps.data.comment" v-if="slotProps.data.comment"/>
                </template>
              </Column>
              <Column field="quantity"></Column>
              <Column field="price">
                <template #body="slotProps">
                  {{ slotProps.data.price ? $n(slotProps.data.price, 'money') : '-' }}
                  {{ slotProps.data.price ? (slotProps.data.currency === 'EUR' ? '€ ' : '$ ') : '' }}
                </template>
              </Column>

              <Column>
                <template #body="slotProps">
                  <div class="p-text-right">
                    <Button :label="$t('orders.buy_again')" class="p-button-outlined" @click="buyAgain(slotProps.data)"/>
                  </div>
                </template>
              </Column>

          </DataTable>

        </div>

        <div class="p-col-12 p-md-6">
          <h3>{{ $t('orders.details.comment') }}</h3>
          <div>{{ order.comment }}</div>
        </div>

        <div class="p-col-12 p-md-6">
          <div class="totals p-mt-4">
            <div class="p-d-flex p-jc-end p-ai-center p-pr-4">
              <div class="">{{ $t('spareParts.cart.total_price') }}</div>
              <div class="p-text-right" style="width: 180px;">
                {{ order.totalPrice ? $n(order.totalPrice, 'money') : '-' }}
                {{ order.totalPrice ? (order.currency === 'EUR' ? '€ ' : '$ ') : '' }}
              </div>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center p-pr-4">
              <div class="">{{ $t('spareParts.cart.priority').toLowerCase() }}</div>
              <div class="p-text-right" style="width: 180px;">
                {{ $t('spareParts.cart.priority_'+order.priority.toLowerCase()) }}
              </div>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center p-pr-4">
              <div class="">{{ $t('spareParts.cart.total_quantity') }}</div>
              <div class="p-text-right" style="width: 180px;">
                {{ totalItems }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <template #footer>
    </template>
  </Dialog>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
  },
  emits: ['update:visible', 'cart:put'],
  props: {
    visible: Boolean,
    order: Object,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
    }),
    totalItems() {
      let total = 0;
      this.order.items.forEach(item => {
        if(item.quantity) {
          total += item.quantity;
        }
      });
      return total;
    }
  },
  created() {
  },
  methods: {
    updateVisible(value) {
      this.$emit("update:visible", value);
    },
    buyAgain(item) {
      this.$emit("cart:put", item.code, item.quantity, true);
    },
    show() {
    },
  }
}
</script>

<style></style>